
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as index6dOyxvyRRyMeta } from "/codebuild/output/src2578232117/src/pages/index.vue?macro=true";
import { default as aboutO0o2w0APpfMeta } from "/codebuild/output/src2578232117/src/pages/about.vue?macro=true";
import { default as data5T3B5csE0JMeta } from "/codebuild/output/src2578232117/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionl82lAmVv4FMeta } from "/codebuild/output/src2578232117/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningwMnKVLnyZ9Meta } from "/codebuild/output/src2578232117/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyzzRgGmMM1zMeta } from "/codebuild/output/src2578232117/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountzoh7LXtnqgMeta } from "/codebuild/output/src2578232117/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statue01PGKsjmdQMeta } from "/codebuild/output/src2578232117/src/pages/account-settings/statue.vue?macro=true";
import { default as supporthNhOve7BFnMeta } from "/codebuild/output/src2578232117/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsIj6uve67CUMeta } from "/codebuild/output/src2578232117/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountBhENB1dAhBMeta } from "/codebuild/output/src2578232117/src/pages/activate-account.vue?macro=true";
import { default as companyKJarIaoySAMeta } from "/codebuild/output/src2578232117/src/pages/admin/company.vue?macro=true";
import { default as consents9nZkf1GVSxMeta } from "/codebuild/output/src2578232117/src/pages/admin/consents.vue?macro=true";
import { default as leadsHjWg2FDt7cMeta } from "/codebuild/output/src2578232117/src/pages/admin/leads.vue?macro=true";
import { default as paymentsTA7LC5smvKMeta } from "/codebuild/output/src2578232117/src/pages/admin/payments.vue?macro=true";
import { default as premium9PIxopuFaUMeta } from "/codebuild/output/src2578232117/src/pages/admin/premium.vue?macro=true";
import { default as profilesxtgPwy8T94Meta } from "/codebuild/output/src2578232117/src/pages/admin/profiles.vue?macro=true";
import { default as usersvwe8iV6srLMeta } from "/codebuild/output/src2578232117/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordN6BBO0mMczMeta } from "/codebuild/output/src2578232117/src/pages/change-password.vue?macro=true";
import { default as _91id_93TcdBh2ZzmmMeta } from "/codebuild/output/src2578232117/src/pages/chat/[id].vue?macro=true";
import { default as ai_46clientONQuASOXnSMeta } from "/codebuild/output/src2578232117/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src2578232117/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexAOIKgHopRPMeta } from "/codebuild/output/src2578232117/src/pages/chat/index.vue?macro=true";
import { default as _91id_93MLn4zu4l8RMeta } from "/codebuild/output/src2578232117/src/pages/client/profile/[id].vue?macro=true";
import { default as indexlSXLMsIsZhMeta } from "/codebuild/output/src2578232117/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_931QfNmS07caMeta } from "/codebuild/output/src2578232117/src/pages/contacts/[id].vue?macro=true";
import { default as indexGWRmzwcytGMeta } from "/codebuild/output/src2578232117/src/pages/contacts/index.vue?macro=true";
import { default as contactsUYwJhG6lFmMeta } from "/codebuild/output/src2578232117/src/pages/contacts.vue?macro=true";
import { default as _91userId_93HT1fWMkdwgMeta } from "/codebuild/output/src2578232117/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexWnvlOUwvPlMeta } from "/codebuild/output/src2578232117/src/pages/login/index.vue?macro=true";
import { default as register_45successdv5fdZxOSYMeta } from "/codebuild/output/src2578232117/src/pages/login/register-success.vue?macro=true";
import { default as logindVm1rKktifMeta } from "/codebuild/output/src2578232117/src/pages/login.vue?macro=true";
import { default as logoutEOgDShgDlcMeta } from "/codebuild/output/src2578232117/src/pages/logout.vue?macro=true";
import { default as consentsTUFFu57zMcMeta } from "/codebuild/output/src2578232117/src/pages/manager/consents.vue?macro=true";
import { default as integrationsTjHKEOiCKTMeta } from "/codebuild/output/src2578232117/src/pages/manager/integrations.vue?macro=true";
import { default as leadsbtboPSyEmZMeta } from "/codebuild/output/src2578232117/src/pages/manager/leads.vue?macro=true";
import { default as paymentscQBOpAXyNbMeta } from "/codebuild/output/src2578232117/src/pages/manager/payments.vue?macro=true";
import { default as profileZzxmRTEJvEMeta } from "/codebuild/output/src2578232117/src/pages/manager/profile.vue?macro=true";
import { default as teamgqUdr9bwSrMeta } from "/codebuild/output/src2578232117/src/pages/manager/team.vue?macro=true";
import { default as indexlXqzTwuenNMeta } from "/codebuild/output/src2578232117/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientL0cUHcb9uTMeta } from "/codebuild/output/src2578232117/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplacetRTePSu6xFMeta } from "/codebuild/output/src2578232117/src/pages/marketplace.vue?macro=true";
import { default as subscribeU5Srf6u8tOMeta } from "/codebuild/output/src2578232117/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientK8kbhTzvgMMeta } from "/codebuild/output/src2578232117/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clienty1vuMGGNTOMeta } from "/codebuild/output/src2578232117/src/pages/orders/my.client.vue?macro=true";
import { default as privacyEs8MidaD96Meta } from "/codebuild/output/src2578232117/src/pages/privacy.vue?macro=true";
import { default as indexe3t5s6m4zfMeta } from "/codebuild/output/src2578232117/src/pages/recover/index.vue?macro=true";
import { default as successuaeJE4g02hMeta } from "/codebuild/output/src2578232117/src/pages/register/success.vue?macro=true";
import { default as _91id_938aG4OynU1BMeta } from "/codebuild/output/src2578232117/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexqSDmUta6MoMeta } from "/codebuild/output/src2578232117/src/pages/sales/profile/index.vue?macro=true";
import { default as statuetrmQ93vMFaMeta } from "/codebuild/output/src2578232117/src/pages/statue.vue?macro=true";
import { default as successDN6zZ2HXtZMeta } from "/codebuild/output/src2578232117/src/pages/subscription/success.vue?macro=true";
import { default as component_45stub1GXQ7qt15xMeta } from "/codebuild/output/src2578232117/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub1GXQ7qt15x } from "/codebuild/output/src2578232117/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index6dOyxvyRRyMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutO0o2w0APpfMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutO0o2w0APpfMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsIj6uve67CUMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsIj6uve67CUMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src2578232117/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountBhENB1dAhBMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountBhENB1dAhBMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyKJarIaoySAMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyKJarIaoySAMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consents9nZkf1GVSxMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consents9nZkf1GVSxMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsHjWg2FDt7cMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsHjWg2FDt7cMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsTA7LC5smvKMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsTA7LC5smvKMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premium9PIxopuFaUMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premium9PIxopuFaUMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesxtgPwy8T94Meta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesxtgPwy8T94Meta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersvwe8iV6srLMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersvwe8iV6srLMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordN6BBO0mMczMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordN6BBO0mMczMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_93TcdBh2ZzmmMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_93TcdBh2ZzmmMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46clientONQuASOXnSMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46clientONQuASOXnSMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: indexAOIKgHopRPMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: indexAOIKgHopRPMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93MLn4zu4l8RMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93MLn4zu4l8RMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexlSXLMsIsZhMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexlSXLMsIsZhMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/client/profile/index.vue")
  },
  {
    name: contactsUYwJhG6lFmMeta?.name,
    path: "/en/contacts",
    meta: contactsUYwJhG6lFmMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_931QfNmS07caMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexGWRmzwcytGMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsUYwJhG6lFmMeta?.name,
    path: "/pl/contacts",
    meta: contactsUYwJhG6lFmMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_931QfNmS07caMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexGWRmzwcytGMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93HT1fWMkdwgMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93HT1fWMkdwgMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index6dOyxvyRRyMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: index6dOyxvyRRyMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/index.vue")
  },
  {
    name: logindVm1rKktifMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src2578232117/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexWnvlOUwvPlMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successdv5fdZxOSYMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: logindVm1rKktifMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src2578232117/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexWnvlOUwvPlMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successdv5fdZxOSYMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutEOgDShgDlcMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutEOgDShgDlcMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsTUFFu57zMcMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsTUFFu57zMcMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsTjHKEOiCKTMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsTjHKEOiCKTMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsbtboPSyEmZMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsbtboPSyEmZMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentscQBOpAXyNbMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentscQBOpAXyNbMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileZzxmRTEJvEMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileZzxmRTEJvEMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamgqUdr9bwSrMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamgqUdr9bwSrMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/manager/team.vue")
  },
  {
    name: marketplacetRTePSu6xFMeta?.name,
    path: "/en/marketplace",
    meta: marketplacetRTePSu6xFMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src2578232117/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientL0cUHcb9uTMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplacetRTePSu6xFMeta?.name,
    path: "/pl/marketplace",
    meta: marketplacetRTePSu6xFMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src2578232117/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientL0cUHcb9uTMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeU5Srf6u8tOMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeU5Srf6u8tOMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientK8kbhTzvgMMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientK8kbhTzvgMMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clienty1vuMGGNTOMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clienty1vuMGGNTOMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2578232117/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyEs8MidaD96Meta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyEs8MidaD96Meta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexe3t5s6m4zfMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexe3t5s6m4zfMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src2578232117/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src2578232117/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_938aG4OynU1BMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_938aG4OynU1BMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexqSDmUta6MoMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexqSDmUta6MoMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statuetrmQ93vMFaMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statuetrmQ93vMFaMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successDN6zZ2HXtZMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successDN6zZ2HXtZMeta || {},
    component: () => import("/codebuild/output/src2578232117/src/pages/subscription/success.vue")
  },
  {
    name: component_45stub1GXQ7qt15xMeta?.name,
    path: "/old-page",
    component: component_45stub1GXQ7qt15x
  }
]